const appServices = process.env.REACT_APP_UI_SERVICES

export default {
  ACCOUNT_MGMT: {
    title: 'CRM - Account Management',
    name: 'CRM',
    image: 'images/account-management.svg',
    basePath: '/crm',
    defaultPagePath: '/crm/users/info',
    isEnabled: appServices?.includes('CRM'),
    USERS: {
      name: 'CRM',
      path: '/crm/users',
      title: 'User Management',
      REGISTER: {
        name: 'CRM',
        title: 'Register',
        path: '/crm/users/register',
        searchFields: [],
        fieldsOrder: [],
      },
      INFO: {
        name: 'CRM',
        title: 'Info',
        path: '/crm/users/info',
        searchFields: [],
        fieldsOrder: [],
      },
      USERS_INFO: {
        name: 'CRM',
        title: 'All user',
        path: '/crm/users/:userId',
        searchFields: [],
        fieldsOrder: [],
      },
      ORDER_DETAILS: {
        name: 'CRM',
        title: 'All Orders',
        path: '/crm/users/:userId/orders/:orderId',
        searchFields: [],
        fieldsOrder: [],
      },
    },
    IN_APP_SUBSCRIPTION: {
      name: 'CRM',
      title: 'In App Subscription',
      path: '/crm/inapp-subscription',
      searchFields: [],
      fieldsOrder: [],
      APPLE: {
        name: 'CRM',
        title: 'Apple',
        path: '/crm/inapp-subscription/apple',
      },
      OTHERS: {
        name: 'CRM',
        title: 'Amazon/Playstore',
        path: '/crm/inapp-subscription/others',
      },
    },
    GUEST_SUBSCRIPTION: {
      name: 'CRM',
      title: 'Guest Subscription',
      path: '/crm/guest-subscription',
      searchFields: [],
      fieldsOrder: [],
    },
    COUPON_STATUS: {
      name: 'CRM',
      title: 'Coupon status',
      path: '/crm/coupon-status',
      searchFields: [],
      fieldsOrder: [],
    },
    REPORTS: {
      name: 'CRM',
      title: 'Reports',
      path: '/crm/reports',
      searchFields: [],
      fieldsOrder: [],
    },
    ATTACH_SUBSCRIPTION: {
      name: 'CRM',
      title: 'Employee subscription',
      path: '/crm/employee-subscription',
      searchFields: [],
      fieldsOrder: [],
    },
  },
  PAY_CMS: {
    title: 'Paycms',
    name: 'PAYCMS',
    image: 'images/paycms.svg',
    basePath: '/paycms',
    defaultPagePath: '/paycms/plans',
    isEnabled: appServices?.includes('PAYCMS'),
    MASTER: {
      title: 'Master',
      path: '/paycms/master',
      PRODUCT: {
        title: 'Product',
        name: 'PAYCMS',
        path: '/paycms/master/products',
      },
      PLATFORM: {
        title: 'Platform',
        name: 'PAYCMS',
        path: '/paycms/master/platforms',
      },
      PARTNER: {
        title: 'Partner',
        name: 'PAYCMS',
        path: '/paycms/master/partners',
      },
      COUNTRY: {
        title: 'Country',
        name: 'PAYCMS',
        path: '/paycms/master/countries',
      },
      PAYMENT_MODE: {
        title: 'Payment mode',
        name: 'PAYCMS',
        path: '/paycms/master/payment-modes',
      },
      PROVIDER: {
        title: 'Provider',
        name: 'PAYCMS',
        path: '/paycms/master/providers',
      },
      MAPPING: {
        title: 'Mapping',
        name: 'PAYCMS',
        path: '/paycms/master/mappings',
      },
    },
    PLANS: {
      title: 'Plans',
      name: 'PAYCMS',
      path: '/paycms/plans',
      CREATE: {
        path: '/paycms/plans/create',
      },
      EDIT: {
        path: '/paycms/plans/edit/:id',
      },
      VIEW: {
        path: '/paycms/plans/view/:id',
      },
    },
    COUPONS: {
      title: 'Coupons',
      name: 'PAYCMS',
      path: '/paycms/coupons',
      searchFields: [
        'couponTitle',
        'couponName',
        'couponType',
        'couponTypeValue',
        'productName',
        'couponCategory',
        'couponStartDate',
        'couponExpDate',
      ],
      LIST: {
        path: '/paycms/coupons/list',
        title: 'List',
        searchFields: [
          'couponTitle',
          'couponName',
          'couponType',
          'couponTypeValue',
          'productName',
          'couponCategory',
          'couponStartDate',
          'couponExpDate',
        ],
      },
      CREATE: {
        path: '/paycms/coupons/create',
      },
      EDIT: {
        path: '/paycms/coupons/edit/:id',
      },
      VIEW: {
        path: '/paycms/coupons/:id',
      },
      REPORTS: {
        title: 'Reports',
        path: '/paycms/coupons/reports',
      },
      STATUS: {
        title: 'Status',
        path: '/paycms/coupons/status',
      },
    },
    OFFERS: {
      title: 'Combos',
      image: 'images/in-progress.svg',
      name: 'PAYCMS',
      path: '/paycms/offers',
      searchFields: [
        'offerId',
        'offerType',
        'perceivedPrice',
        'actualPrice',
        'actualPriceCurrency',
      ],
      CREATE: {
        path: '/paycms/offers/create',
      },
      VIEW: {
        path: '/paycms/offers/:id',
      },
    },
    TRANSLATIONS: {
      title: 'Translations',
      image: 'images/in-progress.svg',
      name: 'PAYCMS',
      path: '/paycms/translations',
      searchFields: [
        'category',
        'subCategory',
        'language',
        'key',
        'customKey',
        'userName',
      ],
      LIST: {
        path: '/paycms/translations',
        title: 'List',
        searchFields: [
          'category',
          'subCategory',
          'language',
          'key',
          'customKey',
          'userName',
        ],
      },
      CREATE: {
        path: '/paycms/translations/create',
        title: 'Create',
      },
      PURGE: {
        path: '/paycms/translations/purge/',
        title: 'Purge',
      },
    },
    REPORTS: {
      title: 'Reports',
      image: 'images/in-progress.svg',
      name: 'PAYCMS',
      path: '/paycms/reports',
      TRANSACTIONS: {
        path: '/paycms/reports/transactions',
        title: 'Transactions',
      },
      EXTRACT_PLANS: {
        path: '/paycms/reports/extractPlans',
        title: 'Plans',
      },
    },
  },
  OFFER_MGMT: {
    title: 'Offer Management',
    name: 'OFFER_ENGINE',
    image: 'images/promotions.svg',
    basePath: '/offers',
    defaultPagePath: '/offers',
    isEnabled: appServices?.includes('OFFER_ENGINE'),
    CREATE: {
      path: '/offers/create',
    },
    VIEW: {
      path: '/offers/view/:id',
    },
    EDIT: {
      path: '/offers/edit/:id',
    },
  },
  PROFILE: {
    name: 'profile',
    path: '/profile',
    title: 'Profile',
    searchFields: [],
    fieldsOrder: [''],
  },
  PAGE_NOT_FOUND: {
    name: 'page-not-found',
    path: '/page-not-found',
    title: 'Page Not Found',
    searchFields: [],
    fieldsOrder: [''],
  },
  ACCESS_DENIED: {
    name: 'access-denied',
    path: '/access-denied',
    title: 'Access Denied',
    searchFields: [],
    fieldsOrder: [''],
  },
  CREATIVES: {
    title: 'Creatives',
    name: 'CREATIVES',
    image: 'images/paycms.svg',
    basePath: '/creatives',
    defaultPagePath: '/creatives/deeplinks',
    isEnabled: appServices?.includes('CREATIVES'),
    DEEPLINK: {
      title: 'Deeplinks',
      name: 'CREATIVES',
      path: '/creatives/deeplinks',
      CREATE: {
        path: '/creatives/deeplinks/create',
      },
      VIEW: {
        path: '/creatives/deeplinks/:code',
      },
      EDIT: {
        path: '/creatives/deeplinks/edit/:code',
      },
    },
  },
}
